import React, { useState } from 'react'
import Header from '../../Layout/Header'
import Footer from '../../Layout/Footer'
import FAQ from './FAQ'
import SeoTagsFooter from './SeoTagsFooter'

function ContactUs() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });
  const [submitting, setSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState('');

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setSubmitStatus('');

    try {
      const formBody = new URLSearchParams();
      // User-entered fields
      formBody.append('name', formData.name);
      formBody.append('email', formData.email);
      formBody.append('phone', formData.phone);
      formBody.append('message', formData.message);
      // Fixed API fields
      formBody.append('action', 'ADD');
      formBody.append('company_url', 'retailer.mokshiq.in');
      formBody.append('subject', 'Contact Us Enquiry');

      const response = await fetch('https://api.mokshiq.in/enquiry-action', {
        method: 'POST',
        headers: {
          Authorization:
            'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX2lkIjoyMDg1LCJjbGllbnRfaWQiOiJjc2Mua3J5bnRpcS5jb20iLCJqdGkiOiIzN2EwNjYyYi04NDg1LTQ0YWUtOTg0ZS03ZjNhOWZiYzMzYjgiLCJpYXQiOjE3ODc0MDA3MTUsImV4cCI6MjEwMjc2MDcxNX0.EhMHAZw7sXm1Q6TCtRlryqBDTwQ68XSHMOq_MQ3B-kk',
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: formBody.toString()
      });

      if (!response.ok) {
        throw new Error(`API Error: ${response.status}`);
      }

      const result = await response.json();
      console.log('Contact Us API Response:', result);

      setSubmitStatus('success');
      setFormData({ name: '', email: '', phone: '', message: '' });
    } catch (error) {
      console.error('Contact Us Request Error:', error);
      setSubmitStatus('error');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="page_wrapper">
        <Header/>
    <main className="page_content">

       
        <section className="page_header text-center bg-dark section_decoration overflow-hidden" style={{ backgroundImage:"url('assets/images/backgrounds/page_header_bg_1.webp')"}}>
          <div className="container">
            <h1 className="page_title text-white">Contact Us</h1>
            <ul className="breadcrumb_nav unordered_list justify-content-center">
              <li><a href="index.html">Home</a></li>
              <li className="active"><a href="#!">Contact Us</a></li>
            </ul>
          </div>
          <div className="decoration_item shape_nate">
            <img src="assets/images/shapes/shape_nate.svg" alt="Shape Nate" />
          </div>
          <div className="decoration_item shape_dollar_1 wow fadeInUp" data-wow-delay=".2s">
            <img src="assets/images/shapes/shape_dollar_1.webp"  data-parallax='{"y" : 100, "smoothness": 10}' alt="Shape Dollar" />
          </div>
          <div className="decoration_item shape_dollar_2 wow fadeInUp" data-wow-delay=".2s">
            <img src="assets/images/shapes/shape_dollar_2.webp" data-parallax='{"y" : 100, "smoothness": 10}' alt="Shape Dollar" />
          </div>
          <div className="decoration_item shape_dollar_3 wow fadeInUp" data-wow-delay=".3s">
            <img src="assets/images/shapes/shape_dollar_3.webp" data-parallax='{"y" : -100, "smoothness": 10}' alt="Shape Dollar" />
          </div>
          <div className="decoration_item shape_dollar_4 wow fadeInUp" data-wow-delay=".3s">
            <img src="assets/images/shapes/shape_dollar_4.webp" data-parallax='{"y" : -100, "smoothness": 10}' alt="Shape Dollar"/>
          </div>
          <div className="decoration_item shape_pattern_1">
            <img src="assets/images/shapes/breadcrumb_shape_pattern_1.svg" alt="Shape Pattern"/>
          </div>
          <div className="decoration_item shape_pattern_2">
            <img src="assets/images/shapes/breadcrumb_shape_pattern_2.svg" alt="Shape Pattern"/>
          </div>
        </section>
       
        <section className="contact_section section_space bg-dark">
          <div className="container">
            <div className="row">
              <div className="col-lg-8">
                <div className="comment_form p-lg-5">
                  <div className="heading_block">
                    <h2 className="heading_text text-dark">
                      Send us a Message
                    </h2>
                    <p className="heading_description mb-0">
                      Give us chance to serve and bring magic to your Finance.
                    </p>
                  </div>

                  {submitStatus === 'success' && (
                    <div className="alert alert-success py-2 small mb-3" role="alert">
                      Thank you! Your message has been sent successfully. Our team will contact you shortly.
                    </div>
                  )}
                  {submitStatus === 'error' && (
                    <div className="alert alert-danger py-2 small mb-3" role="alert">
                      Something went wrong. Please try again or contact us directly.
                    </div>
                  )}

                  <form onSubmit={handleFormSubmit}>
                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group">
                          <label className="input_title" htmlFor="input_name">Name<sup>*</sup></label>
                          <input id="input_name" className="form-control" type="text" name="name" value={formData.name} onChange={handleFormChange} placeholder="Carlo Castillo" required />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label className="input_title" htmlFor="input_email">Email<sup>*</sup></label>
                          <input id="input_email" className="form-control" type="email" name="email" value={formData.email} onChange={handleFormChange} placeholder="alma.lawson@example.com" required />
                        </div>
                      </div>
                      <div className="col-12">
                        <div className="form-group">
                          <label className="input_title" htmlFor="input_phone">Phone<sup>*</sup></label>
                          <input id="input_phone" className="form-control" type="tel" name="phone" value={formData.phone} onChange={handleFormChange} placeholder="+88 (0) 101 0000 000" required />
                        </div>
                        <div className="form-group">
                          <label className="input_title" htmlFor="input_message">Cover Letter<sup>*</sup></label>
                          <textarea id="input_message" className="form-control" name="message" value={formData.message} onChange={handleFormChange} placeholder="Write about your self..." required></textarea>
                        </div>
                        <button className="btn text-dark" type="submit" disabled={submitting}>
                          <span className="btn_label">{submitting ? 'Sending...' : 'Send Message'}</span>
                          <span className="btn_icon ml-10"><svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M19.7071 8.70711C20.0976 8.31658 20.0976 7.68342 19.7071 7.29289L13.3431 0.928932C12.9526 0.538408 12.3195 0.538408 11.9289 0.928932C11.5384 1.31946 11.5384 1.95262 11.9289 2.34315L17.5858 8L11.9289 13.6569C11.5384 14.0474 11.5384 14.6805 11.9289 15.0711C12.3195 15.4616 12.9526 15.4616 13.3431 15.0711L19.7071 8.70711ZM0 9H19V7H0V9Z" fill="#012A2B" />
                          </svg></span>
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="contact_info_box p-5">
                  <h3 className="heading_text text-dark">Contact Info</h3>
                  <ul className="iconlist_block unordered_list_block">
                    <li>
                      <a href="tel:+917311104571">
                        <span className="iconlist_icon">
                          <img src="assets/images/icons/icon_calling_3.svg" alt="Icon Calling"/>
                        </span>
                        <span className="iconlist_text text-dark"><strong>Sales/Call:</strong> +91 7311104571</span>
                      </a>
                    </li>
                    <li>
                      <a href="mailto:sales@mokshiq.in">
                        <span className="iconlist_icon">
                          <img src="assets/images/icons/icon_email_3.svg" alt="Icon Email"/>
                        </span>
                        <span className="iconlist_text text-dark"><strong>Sales:</strong> sales@mokshiq.in</span>
                      </a>
                    </li>
                    <li>
                      <a href="mailto:support@mokshiq.in">
                        <span className="iconlist_icon">
                          <img src="assets/images/icons/icon_email_3.svg" alt="Icon Email"/>
                        </span>
                        <span className="iconlist_text text-dark"><strong>Support:</strong> support@mokshiq.in</span>
                      </a>
                    </li>
                    <li>
                      <a href="mailto:career@mokshiq.in">
                        <span className="iconlist_icon">
                          <img src="assets/images/icons/icon_email_3.svg" alt="Icon Email"/>
                        </span>
                        <span className="iconlist_text text-dark"><strong>Career:</strong> career@mokshiq.in</span>
                      </a>
                    </li>
                  </ul>
                  <ul className="social_icons_block unordered_list mb-0">
                    <li>
                      <a aria-label="Twitter X" href="#!">
                        <svg viewBox="0 0 15 15" xmlns="http://www.w3.org/2000/svg">
                          <path d="M8.92704 6.35148L14.5111 0H13.1879L8.33921 5.5149L4.4666 0H0L5.85615 8.3395L0 15H1.32333L6.44364 9.17608L10.5334 15H15L8.92671 6.35148H8.92704ZM7.11456 8.41297L6.52121 7.58255L1.80014 0.974755H3.83269L7.64265 6.30746L8.236 7.13788L13.1885 14.0696H11.156L7.11456 8.41329V8.41297Z"></path>
                        </svg>
                      </a>
                    </li>
                    <li><a aria-label="Facebook" href="#!"><i className="fa-brands fa-facebook-f"></i></a></li>
                    <li><a aria-label="Linkedin" href="#!"><i className="fa-brands fa-linkedin-in"></i></a></li>
                  </ul>
                  <hr />
                  <ul className="office_location iconlist_block unordered_list_block mb-0">
                    <li>
                      <span className="iconlist_text text-dark">
                        <strong className="text-dark d-block">Brand &amp; Product:</strong> Mokshiq
                      </span>
                    </li>
                    <li>
                      <span className="iconlist_text text-dark">
                        <strong className="text-dark d-block">Parent Entity:</strong> Rakle Service Private Limited
                      </span>
                    </li>
                    <li>
                      <span className="iconlist_text text-dark">
                        <strong className="text-dark d-block">Corporate Office Address:</strong> 1st Floor, C 78, Sector-2 Noida, Uttar Pradesh
                      </span>
                    </li>
                  </ul>
                  <hr />
                  <ul className="iconlist_block unordered_list_block mb-0">
                    <li>
                      <span className="iconlist_text text-dark">
                        <strong className="text-dark d-block">Our Office Hours:</strong> Mon - Sat : 9:00 AM - 6:00 PM <mark className="d-block text-danger">Sunday : Closed</mark>
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>
        <div className="gmap_canvas bg-light">
          <iframe 
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3503.738118029314!2d77.31341107626922!3d28.577622975694084!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390ce4599a0937a7%3A0xb3bd6a13d7be2742!2sSector%202%2C%20Noida%2C%20Uttar%20Pradesh%20201301!5e0!3m2!1sen!2sin!4v1700000000000!5m2!1sen!2sin" 
            width="100%" 
            height="450" 
            style={{ border: 0 }} 
            allowFullScreen="" 
            loading="lazy" 
            referrerPolicy="no-referrer-when-downgrade"
            title="Mokshiq Noida Office Location"
          ></iframe>
        </div>

        <FAQ 
          title="Contact & Support Frequently Asked Questions"
          subtitle="Have questions about getting started, partnerships, or technical APIs? Reach out to us anytime."
        />
      </main>
      <Footer/>
      <SeoTagsFooter/>
    </div>
  )
}

export default ContactUs